import { FavoriteType } from '~/types/common/user';

export const generateFavoriteId = (type: FavoriteType, code: string) => {
  return type + '-' + code;
};
